<template>
  <a :href="`/angebote/${event.permalink}`"
     :class="className"
     :title="label"
     :aria-label="label">
    Details
  </a>
</template>

<script>
export default {
  props: ['event', 'className'],
  computed: {
    label() {
      const { title, district, park } = this.event;
      return `Details zum Bewegungsangebot "${title}" in ${district || 'Berlin'} (${park})`;
    }
  }
}
</script>
